import _ from 'lodash'

function redirect (query, router) {
  let hostname = extractHostname(query)

  if (!_.isEmpty(query) && query.redirect) {
    if (hostname) {
      // External redirect
      location.href = query.redirect
    } else {
      // Internal redirect
      router.push(query.redirect)
    }
  } else {
    // Navigate to home because of direct access without redirect query parameter
    router.push({ name: 'Home' })
  }
}

function extractHostname (query) {
  if (!_.isEmpty(query) && query.redirect) {
    // From https://stackoverflow.com/a/15979390
    let parser = document.createElement('a')
    parser.href = query.redirect

    // Only return hostname if query.redirect is not a relative URL
    if (parser.hostname !== location.hostname) {
      return parser.hostname
    }
  }

  return null
}

export { redirect, extractHostname }
